/**
 * 8Ball Padel's own card, on every league page.
 *
 * Was a one-line "Powered by" credit with the tagline hidden in its aria-label,
 * where no one reads it. It now says the line out loud, because a league page is
 * where the next organiser finds us: someone playing in Vitalli who runs a
 * league of their own is exactly who this is for.
 *
 * Still understated. Inside a league the platform is the host, not the headline,
 * so this uses the single-colour mark and the same quiet dark card the sponsors
 * get, rather than the vibrant lockup saved for 8Ball's own pages. The mark is
 * white with transparency and tinted by CSS, so it sits correctly on Society's
 * navy-and-lime and Vitalli's navy-and-gold alike.
 *
 * On a league's own domain the card stays but the link has to leave. `#/` there
 * is that league's own front page — the platform is not at this address — so
 * the one card whose entire purpose is to lead somewhere would have led back to
 * where the reader already was. Off the platform it becomes an ordinary
 * outbound link, opened in its own tab so a captain does not lose the table she
 * was reading. Nobody is sent to 8ballpadel.com; anyone curious can still reach
 * it.
 */
export default function PoweredBy({ offPlatform = false }: { offPlatform?: boolean }) {
  const away = offPlatform
    ? { href: 'https://8ballpadel.com/', target: '_blank', rel: 'noreferrer' }
    : { href: '#/' };

  return (
    <a className="powered-card" {...away}>
      <span className="powered-text">
        <span className="powered-lab">Brought to you by</span>
        <strong>8Ball Padel</strong>
        <span className="powered-tag">The home of padel leagues!</span>
      </span>
      <img src="/brand/8ball-mono.png" alt="" aria-hidden="true" />
    </a>
  );
}
